import Vue from 'vue';

Vue.component('promotion-report-index', () =>
    import(/* webpackChunkName: 'promotion-report-index' */ './promotion-report-index.vue'),
);

Vue.component('promotion-report-table', () =>
    import(/* webpackChunkName: 'promotion-report-table' */ './promotion-report-table.vue'),
);

Vue.component('pwp-promotion-table', () =>
    import(/* webpackChunkName: 'pwp-promotion-table' */ './pwp-promotion-table.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/promotion/index.js